import { createLayout } from './createLayout'
import { LG_MAX, LG_MIN, MD_MAX, MD_MIN, SIDEBAR_MAX } from './MobileBreakPoint'
import { Theme } from './types'
import { Theme as UiKitTheme } from './uiKit/theme'

export const defaultTheme: Theme = {
  ui: UiKitTheme,
  /** @deprecated use mq from UIKit theme */
  mq: {
    md: `(max-width: ${MD_MAX}px) and (min-width: ${MD_MIN}px)`,
    lg: `(max-width: ${LG_MAX}px) and (min-width: ${LG_MIN}px)`,
    xl: `(min-width: ${LG_MAX}px)`,
    sideBarCollapsed: `(max-width: ${SIDEBAR_MAX}px)`,
  },
  maxWidth: { lg: '1200px', md: '720px', xs: '100%' },
}

export const ThemeProvider = createLayout(defaultTheme)
